import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'

import BookingFailed from '../../../src/assets/images/BookingFailed.png'
import { getTodayDate } from '../../helpers/date'
import { getInitialReferer } from '../../helpers/elements'
import { getTranslate, lang } from '../../localization'
import { useStyles } from './styles/index.styles'

function PaymentError() {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.root}>
      <div className={classes.main}>
        <div className={classes.header}>
          <img src={BookingFailed} className={classes.img} />
          <div className={classes.right}>
            <div className={classes.headerRow}>
              <div>
                <Typography className={classes.title}>
                  {getTranslate('Oops, Your Reservation Failed')}
                </Typography>
              </div>
              <div className={classes.date}>
                <Typography variant="h6">
                  {`${getTranslate('Payment Date')}: ${getTodayDate(lang)}`}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.btnContainer}>
          <Button
            variant="text"
            className={classes.btn}
            onClick={() => {
              const initialRef = getInitialReferer()
              window.location.href = initialRef || '/'
            }}>
            <Typography variant="h5" className={classes.redText}>
              {getTranslate(isSmall ? 'Booking ' : 'Back to Booking')}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PaymentError
